import { render, staticRenderFns } from "./icon-button.vue?vue&type=template&id=17621daf&"
import script from "./icon-button.vue?vue&type=script&lang=js&"
export * from "./icon-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports